import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import installElementPlus from './plugins/element'
// 在 main.js 中引入
// import VueUeditorWrap from 'vue-ueditor-wrap'
// main.js
// 统一导入el-icon图标
import * as ElIconModules from '@element-plus/icons-vue'
// 导入转换图标名称的函数
import { transElIconName } from './utils/utils.js'

import 'default-passive-events'

const app = createApp(App)
installElementPlus(app)
app.use(store).use(router)
    //.component('vue-ueditor-wrap', VueUeditorWrap)
    .mount('#app')
// 统一注册el-icon图标
for (let iconName in ElIconModules) {
    app.component(transElIconName(iconName), ElIconModules[iconName])
}
